import {VsiBubble, VsiH4, VsiH5, VsiHr} from "../../../../styled/App.styled";
import {useDataWithRoute, useTitleFromComponent} from "../../../../utils/hooks";
import Grid from "../../../../components/Grid";
import {Card, CardText, CardTitle, Col, Row, Spinner} from "reactstrap";
import {useVsiAppContext} from "../../../../stores/VsiApp";
import { databaseInstanceDetailRefs } from "../../../../utils/gridColumnDefs/databases/databaseInstanceDetailDefs";
import { useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import AtAGlance from "../../../../components/AtAGlance";
import themeStyles from "../../../../utils/themeStyles";
import Stockchart from "../../../../components/Stockchart";
import graphImg from "../../../../assets/images/noun-line-graph-251713-9B9B9B.svg";
import { healthColorAlertFormatter } from "../../../../utils/gridFormatters";
import PieChart from "../../../../components/PieChart";

const databaseInstanceAag = [
    {
        field: "instance",
        mobile: true,
    },
    {
        field: "host",
        mobile: true
    },
    {
        title: "Host OS",
        field: "host_os",
        mobile: true,
    },
    {
        field: "type",
        mobile: true,
    },
    {
        field: "version",
        mobile: true,
    },
    {
        field: "used",
        mobile: true,
    },
    {
        field: "free"
    },
    {
        field: "allocated"
    },
    {
        field: "num_databases"
    },
    {
        field: "default_collation"
    },
    {
        field: "uptime"
    },
    {
        field: "backup_status"
    }
];

export default function DatabaseIntanceDetail({title}){
    useTitleFromComponent(title)
    const [searchParams] = useSearchParams();
    const { theme, client, periodId } = useVsiAppContext();

    const instanceName = decodeURIComponent(searchParams.get("instance_name"));
    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/database_server_instance_detail_proc?client_id=${client.clientId}&period_id=${periodId}&instance_name=${encodeURIComponent(instanceName)}`);

    const [databaseInstanceDetail, setDatabaseInstanceDetail] = useState([]);
    const [capacityTrend, setCapacityTrend] = useState([]);
    const [databaseInstanceDetailGrid, setDatabaseInstanceDetailGrid] = useState([]);
    const [databaseInstanceDetailAag, setDatabaseInstanceDetailAag] = useState([]);
    const [healthAlert, setHealthAlert] = useState('');
    const [capacityTrendSeries, setCapacityTrendSeries] = useState([]);
    const [pieChartSeries, setPieChartSeries] = useState([]);
    const [performanceTrendSeries, setPerformanceTrendSeries] = useState([]);

    useEffect(() => {
        setDatabaseInstanceDetail(data);
        setDatabaseInstanceDetailAag(data?.recordsets?.[0]?.[0] || {});
        setHealthAlert(healthColorAlertFormatter({value: data?.recordsets?.[0]?.[0]?.backup_status?.toLowerCase()}))
        setCapacityTrend(data?.recordsets?.[1] || []);
        getDatabaseBySpacePieChart(data?.recordsets?.[2] || []);
        setPerformanceTrendSeries(data?.recordsets?.[3] || []);
        setDatabaseInstanceDetailGrid(data?.recordsets?.[5] || []);
    }, [data]);

    const getCapacityTrendChart = () => {
        // first find out if we even have enough data to graph. We need two points at a minimum.
        if (capacityTrend && capacityTrend.length > 1) {
            const utilizationLineData = [];
            const capacityLineData = [];
            const allocatedLineData = [];

            // at least two data points
            // const graphDate1 = Date.parse(capacityTrend[0]['collection_date']?.split?.('T')?.[0]);
            // const graphDate2 = Date.parse(capacityTrend[1]['collection_date']?.split?.('T')?.[0]);
            //
            // utilizationLineData.push([graphDate1, capacityTrend[0]['used']] || 0);
            // utilizationLineData.push([graphDate2, capacityTrend[1]['used']] || 0);
            //
            // capacityLineData.push([graphDate1, capacityTrend[0]['free']] || 0);
            // capacityLineData.push([graphDate2, capacityTrend[1]['free']] || 0);
            //
            // allocatedLineData.push([graphDate1, capacityTrend[0]['allocated']] || 0);
            // allocatedLineData.push([graphDate2, capacityTrend[1]['allocated']] || 0);

            // 3 data points

            for (let i = capacityTrend.length - 1; i > capacityTrend.length - 5; i--) {
                const capacityTrendInfo = capacityTrend?.[i];

                if (capacityTrendInfo) {
                    const graphDate = Date.parse(capacityTrendInfo['collection_date']?.split?.('T')?.[0]);
                    utilizationLineData.push([graphDate, capacityTrendInfo['used']] || 0);
                    capacityLineData.push([graphDate, capacityTrendInfo['free']] || 0);
                    allocatedLineData.push([graphDate, capacityTrendInfo['allocated']] || 0);
                }
            }

            // if (capacityTrend[2]?.['collection_date']) {
            //     const graphDate3 = Date.parse(capacityTrend[2]['collection_date']?.split?.('T')?.[0]);
            //     utilizationLineData.push([graphDate3, capacityTrend[2]['used']] || 0);
            //     capacityLineData.push([graphDate3, capacityTrend[2]['free']] || 0);
            //     allocatedLineData.push([graphDate3, capacityTrend[2]['allocated']] || 0);
            // }
            //
            // // 4 data points
            // if (capacityTrend[3]?.['collection_date']) {
            //     const graphDate4 = Date.parse(capacityTrend[3]['collection_date']?.split?.('T')?.[0]);
            //     utilizationLineData.push([graphDate4, capacityTrend[3]['used']] || 0);
            //     capacityLineData.push([graphDate4, capacityTrend[3]['free']] || 0);
            //     allocatedLineData.push([graphDate4, capacityTrend[3]['allocated']] || 0);
            // }
            //
            // // 5 data points
            // if (capacityTrend[4]?.['collection_date']) {
            //     const graphDate5 = Date.parse(capacityTrend[4]['collection_date']?.split?.('T')?.[0]);
            //     utilizationLineData.push([graphDate5, capacityTrend[4]['used']] || 0);
            //     capacityLineData.push([graphDate5, capacityTrend[4]['free']] || 0);
            //     allocatedLineData.push([graphDate5, capacityTrend[4]['allocated']] || 0);
            // }

            utilizationLineData.sort((a, b) => a[0] - b[0]);
            capacityLineData.sort((a, b) => a[0] - b[0]);
            allocatedLineData.sort((a, b) => a[0] - b[0]);

            const capacityTrendChartConfig = {
                "yAxis": [
                    {"title": {"text": "Used (GiB)"}}
                ],
                "colors": ["#099c9d", themeStyles[theme].textColor, "#B0EA3B", "#ff8d02", "#004577"]
            }

            const capacityTrendDataTemplate = [
                {
                    "name": "Utilization",
                    "type": null,
                    "data": utilizationLineData,
                    "dashStyle": "Solid",
                    "yAxis": 0,
                    "tooltip": {
                        "valueDecimals": 2
                    },
                    "marker": {
                        "enabled": true
                    },
                    "zoneAxis": null,
                    "zones": null
                },
                {
                    "name": "Capacity",
                    "type": null,
                    "data": capacityLineData,
                    "dashStyle": "Solid",
                    "yAxis": 0,
                    "tooltip": {
                        "valueDecimals": 2
                    },
                    "marker": {
                        "enabled": true
                    },
                    "zoneAxis": null,
                    "zones": null
                },
                {
                    "name": "Allocation",
                    "type": null,
                    "data": allocatedLineData,
                    "dashStyle": "Solid",
                    "yAxis": 0,
                    "tooltip": {
                        "valueDecimals": 2
                    },
                    "marker": {
                        "enabled": true
                    },
                    "zoneAxis": null,
                    "zones": null
                }
            ];

            if(!capacityTrendSeries.length) {
                setCapacityTrendSeries(capacityTrendDataTemplate)
            }

            return (<Stockchart navDisabled={true}
                                height={450}
                                series={capacityTrendDataTemplate}
                                rangeSelectorDisabled={true}
                                config={capacityTrendChartConfig}/>);

        } else {
            // return "not enough data" card.
            return (
                <Card style={{maxHeight: 480}} className={`report-card p-2 nav-card-${theme}`}>
                    <img src={graphImg} style={{maxHeight: 360}}/>
                    <CardTitle tag="h5" style={{color: themeStyles[theme].textColor, paddingLeft: 6, paddingRight: 6}}>
                        Not enough data
                    </CardTitle>
                    <CardText style={{color: themeStyles[theme].textColor, paddingLeft: 6, paddingRight: 6}}>
                        There aren't enough data points to graph yet. As you collect more data for this device, you'll see a
                        trend chart for capacity metrics here.
                    </CardText>
                </Card>
            );
        }
    };

    const getDatabaseBySpacePieChart = (spacePieChartData) => {
        let pieData = []
        for (let i = 0; i < spacePieChartData.length; i++) {
            pieData.push({name: spacePieChartData?.[i]?.tablespace_name, y: spacePieChartData?.[i]?.used})
        }
        setPieChartSeries(pieData);
    };

    const getPerformanceTrendChart = () => {
        // like with capacity, you need at least two points to graph so make sure we have at least two dates
        if (performanceTrendSeries && performanceTrendSeries.length > 1) {
            const iopsData = [];
            // Just graphing iops for the moment
            // const latencyData = [];

            const graphDate1 = Date.parse(performanceTrendSeries[0]['collection_date']?.split?.('T')?.[0]);
            const graphDate2 = Date.parse(performanceTrendSeries[1]['collection_date']?.split?.('T')?.[0]);

            iopsData.push([graphDate1, performanceTrendSeries[0]['iops']] || 0);
            iopsData.push([graphDate2, performanceTrendSeries[1]['iops']] || 0);

            // 3 data points
            if (performanceTrendSeries[2]?.['collection_date']) {
                const graphDate3 = Date.parse(performanceTrendSeries[2]['collection_date']?.split?.('T')?.[0]);
                iopsData.push([graphDate3, performanceTrendSeries[2]['iops'] || 0]);
            }

            // 4 data points
            if (performanceTrendSeries[3]?.['collection_date']) {
                const graphDate4 = Date.parse(performanceTrendSeries[3]['collection_date']?.split?.('T')?.[0]);
                iopsData.push([graphDate4, performanceTrendSeries[3]['iops'] || 0]);
            }

            // 5 data points
            if (performanceTrendSeries[4]?.['collection_date']) {
                const graphDate5 = Date.parse(performanceTrendSeries[4]['collection_date']?.split?.('T')?.[0]);
                iopsData.push([graphDate5, performanceTrendSeries[4]['iops'] || 0]);
            }

            iopsData.sort((a, b) => a[0] - b[0]);

            const capacityTrendChartConfig = {
                "yAxis": [
                    {"title": {"text": "IOPS"}},
                ],
                "colors": ["#099c9d", "#B0EA3B"]
            }

            const performanceTrendDataTemplate = [
                {
                    "name": "IOPS",
                    "type": null,
                    "data": iopsData,
                    "dashStyle": "Solid",
                    "yAxis": 0,
                    "tooltip": {
                        "valueDecimals": 2
                    },
                    "marker": {
                        "enabled": true
                    },
                    "zoneAxis": null,
                    "zones": null
                }
            ];

            if(!performanceTrendSeries.length) {
                setPerformanceTrendSeries(performanceTrendDataTemplate)
            }

            return (<Stockchart navDisabled={true}
                                height={450}
                                series={performanceTrendDataTemplate}
                                rangeSelectorDisabled={true}
                                config={capacityTrendChartConfig}/>);

        } else {
            return (<div style={{marginTop: 16}}><Card className={`report-card p-2 nav-card-${theme}`}>
                <img src={graphImg} style={{maxHeight: 360}}/>
                <CardTitle tag="h5" style={{color: themeStyles[theme].textColor, paddingLeft: 6, paddingRight: 6}}>
                    Not enough data
                </CardTitle>
                <CardText style={{color: themeStyles[theme].textColor, paddingLeft: 6, paddingRight: 6}}>
                    There aren't enough data points to graph yet. As you collect more data for this device, you'll see a
                    trend chart for capacity metrics here.
                </CardText>
            </Card></div>);
        }
    };

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Database Instance Detail</VsiH4>
            <VsiH5>Configuration Summary</VsiH5>
            <VsiBubble className={`mb-2 p-2`} autobotInfo={{
                data: databaseInstanceDetail,
                config: databaseInstanceAag
            }}>
                <AtAGlance config={databaseInstanceAag} data={{
                    instance: databaseInstanceDetailAag?.instance,
                    host: databaseInstanceDetailAag?.host,
                    host_os: databaseInstanceDetailAag?.host_os,
                    type: databaseInstanceDetailAag?.type,
                    version: databaseInstanceDetailAag?.version,
                    used: databaseInstanceDetailAag?.used,
                    free: databaseInstanceDetailAag?.free,
                    allocated: databaseInstanceDetailAag?.allocated,
                    num_databases: databaseInstanceDetailAag?.num_databases,
                    default_collation: databaseInstanceDetailAag?.default_collation,
                    uptime: databaseInstanceDetailAag?.uptime,
                    backup_status: healthAlert,
                }} size={"lg"}/>
            </VsiBubble>
            <VsiHr/>
            <VsiBubble autobotName='databaseInstanceDetailGraphs' autobotInfo={{ data: {
                capacityStockChart: {data: capacityTrendSeries},
                pieChart: {data: pieChartSeries},
                performanceStockChart: {data: performanceTrendSeries}
            } }}>
                <Row className={"mb-2"} style={{paddingLeft: 6, paddingRight: 6}}>
                    <Col xs={12} lg={4}>
                        <div style={{cursor: 'pointer'}}>
                            <VsiH5>Capacity Trend</VsiH5>
                            {isLoading ? <Spinner color={"primary"}/> : getCapacityTrendChart()}
                        </div>
                    </Col>
                    <Col xs={12} lg={4}>
                        <div>
                            <VsiH5>Space by Table / Database</VsiH5>
                            {isLoading ? <Spinner color={"primary"}/> : 
                                <PieChart
                                    height={450}
                                    includeLegend={true}
                                    series={[{
                                        name: "Space by Table Space / Database",
                                        data: pieChartSeries
                                    }]}
                                />}
                        </div>
                    </Col>
                    <Col xs={12} lg={4}>
                        <div>
                            <VsiH5>Hardware Performance</VsiH5>
                            {isLoading ? <Spinner color={"primary"}/> : getPerformanceTrendChart()}
                        </div>
                    </Col>
                </Row>
            </VsiBubble>
            <VsiBubble>
                <Grid addStyle
                      data={databaseInstanceDetailGrid}
                      isLoading={isLoading}
                      columnDefs={databaseInstanceDetailRefs}/>
            </VsiBubble>
        </Card>
    );
}
